import { atom } from "recoil";
import { Mode } from "../components/types/user";
export const modeState = atom<Mode>({
  key: "modeState",
  default: "dark",
});
